// Informações do hotel — edite apenas este arquivo para atualizar o site.
const hotelInfo = {
  nome: 'Hotel Santa Rita',
  slogan: 'Sua casa fora de casa.',

  endereco: 'Rua Professora Santa Vieira de Castro, 117 — Centro',
  telefone: {
    exibicao: '(77) 3450-1237',
    link: 'tel:+557734501237',
  },
  whatsapp: {
    exibicao: '(77) 99823-7355',
    link: 'https://wa.me/5577998237355',
  },
  instagram: {
    exibicao: '@hotel.santa.rita',
    link: 'https://instagram.com/hotel.santa.rita',
  },

  // Link "Incorporar um mapa" do Google Maps (apenas a URL do atributo src).
  mapaEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15509.935529230977!2d-41.330753699999995!3d-13.6283037!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x743fcee95d2e059%3A0xe07356b8e0d45b8c!2sHotel%20Santa%20Rita!5e0!3m2!1spt-BR!2sbr!4v1748729534447!5m2!1spt-BR!2sbr',
};

export default hotelInfo;
